/**
 * lib/views/javascripts/shared/boot-data.js — reads the JSON a page's server
 * wrote with views.bootData (ADR 0082 D7).
 *
 * The server never concatenates a value into script source; it writes one
 * <script type="application/json" id="m33-boot-data"> block and the page's
 * module reads it here. A missing or malformed block is a server bug, so it
 * throws, tagged (rule 14).
 *
 * Contents: view
 * Ontology: Code object M33C-1010 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── Reading ──────────────────────────────────────────────────────────────
export function readBootData(doc = document, id = 'm33-boot-data') {
  const el = doc.getElementById(id);
  if (!el) throw new Error(`[views:boot-data] no #${id} block on this page`);
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    throw new Error(`[views:boot-data] #${id} is not valid JSON: ${String(e.message).slice(0, 120)}`);
  }
}
